module.exports = __webpack_public_path__ + "img/06.ae948eda.jpg";